import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

const ComboSensorWidgetWithIcon = ({
  Icon1,
  Icon2,
  width = 46,
  height = 40,
  borderColor,
  backgroundColor,
  circleColor,
  ...rest
}: {
  Icon1: React.ReactNode;
  Icon2: React.ReactNode;
  width?: number;
  height?: number;
  borderColor?: string;
  backgroundColor?: string;
  circleColor?: string;
  [key: string]: unknown;
}) => {
  const { token } = useToken();
  const currentBorderColor = borderColor ?? token.colorBorder;
  const currentBackgroundColor = backgroundColor ?? token.colorBgBase;
  const currentCircleColor = circleColor ?? token.colorPrimary;

  return (
    <svg width={width} height={height} viewBox="0 0 78 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M4 14H2C0.895431 14 0 14.8954 0 16V24C0 25.1046 0.895431 26 2 26H4C4 26 2 20 4 14Z"
        fill={token.colorBorder}
      />
      <rect x="4.5" y="1.5" width="69" height="37" rx="18.5" fill={currentBackgroundColor} />
      <rect x="4.5" y="1.5" width="69" height="37" rx="18.5" stroke={currentBorderColor} strokeWidth="3" />
      <circle cx="23" cy="20" r="12" fill={currentCircleColor} />
      {Icon1}
      <circle cx="55" cy="20" r="12" fill={currentCircleColor} />
      {Icon2}
      <path
        d="M74 14H76C77.1046 14 78 14.8954 78 16V24C78 25.1046 77.1046 26 76 26H74C74 26 76 20 74 14Z"
        fill={token.colorBorder}
      />
    </svg>
  );
};

export default ComboSensorWidgetWithIcon;
